<template lang="html">
  <div class="timeline"
    :style="getStyle"
    @mousedown="mousedownHandler($event)"
    @mousemove="mousemoveHandler($event)"
    @mouseup="mouseupHandler($event)"
    @click="clickHandler($event)"
  >
  </div>
</template>

<script>
// import T from '@/modules/time'
import { mapGetters } from 'vuex'

export default {
  name: 'timeline',
  props: [
    'classroom',
    'dragging'
  ],
  data () {
    return {
      style: {
        width: this.$store.state.columnWidth * this.$store.state.mobileWidthMagnification + 'px' // あとで変数に変更の必要あり
      }
    }
  },
  methods: {
    mousedownHandler (event) {
      this.$emit('tlmousedown', {
        e: event,
        classroom: this.classroom
      })
    },
    mousemoveHandler (event) {
      if (this.dragging) {
        this.$emit('tlmousemove', {
          e: event,
          classroom: this.classroom
        })
      }
    },
    mouseupHandler (event) {
      this.$emit('tlmouseup', {
        e: event,
        classroom: this.classroom
      })
    },
    clickHandler (event) {
      this.$emit('tlclick', {
        e: event,
        classroom: this.classroom
      })
    }
  },
  computed: {
    ...mapGetters([
      'timelineHeight',
      'positionToTime',
      'getLeftPosOfClassroom',
      'getClassroomAt',
      'edgeClassrooms'
    ]),
    getStyle () {
      this.style.height = this.timelineHeight * this.$store.state.mobileHeightMagnification + 'px'
      this.style.left = this.getLeftPosOfClassroom(this.classroom) * this.$store.state.mobileWidthMagnification + 'px'
      if (this.edgeClassrooms.some((elem, index, self) => {
        return elem.name === this.classroom
      })) {
        this.style['border-right-width'] = '2px'
        this.style['border-right-style'] = 'solid'
        this.style['border-right-color'] = 'black'
      }

      return this.style
    }
  }
}
</script>

<style lang="css">
.timeline {
  box-sizing: border-box;
  position: absolute;
  top: 0px;

  background-color: #FFFFFF;
  opacity: 0.2;

  border-right-style: solid;
  border-right-color: #cccccc;
  border-right-width: 1px;

  z-index: 999;
}
.timeline:hover {
  background-color: #fff3ba;
}
</style>



// WEBPACK FOOTER //
// SpTimeline.vue?5fa5cf0a